import { FixtureStatuses } from "enums/fixtureStatuses";
import { Roles } from "enums/roles";
import { RosterPositions } from "enums/rosterPositions";
import { UniformItemBottomTypes } from "enums/uniformItemBottomTypes";
import { UniformItemColors } from "enums/uniformItemColors";
import { UniformItemTopTypes } from "enums/uniformItemTopTypes";
import { UniformItemTypes } from "enums/uniformItemTypes";
import type { SportConfiguration } from "types/sportConfiguration";
import { defaultsConfig } from "./defaults";

const rosterPositions: Array<RosterPositions> = [
  RosterPositions.CenterBackcourt,
  RosterPositions.DefensiveSpecialist,
  RosterPositions.Goalkeeper,
  RosterPositions.LeftBackcourt,
  RosterPositions.LeftWingman,
  RosterPositions.Pivot,
  RosterPositions.RightBackcourt,
  RosterPositions.RightWingman,
];

const staffRoles: Array<Roles> = [
  Roles.Delegate,
  Roles.CoachHead,
  Roles.CoachAssistant,
  Roles.Director,
  Roles.MediaOfficer,
  Roles.Trainer,
  Roles.OFFICIAL_A,
  Roles.OFFICIAL_B,
  Roles.OFFICIAL_C,
  Roles.OFFICIAL_D,
];

const seasonStaffRoles = staffRoles;
const fixtureStaffRoles = staffRoles;

const uniforms: SportConfiguration["uniforms"] = {
  bottomOptions: [UniformItemBottomTypes.Shorts],
  items: [
    {
      titleIntlKey: "uniformModal.preview.player",
      topType: [UniformItemTopTypes.ShortSleeve],
      itemTypes: {
        [UniformItemTypes.Top]: [UniformItemColors.Primary, UniformItemColors.Secondary],
        [UniformItemTypes.Bottom]: [UniformItemColors.Primary],
        [UniformItemTypes.Socks]: [UniformItemColors.Primary],
      },
    },
    {
      titleIntlKey: "uniformModal.preview.goalkeeper",
      topType: [UniformItemTopTypes.LongSleeve],
      itemTypes: {
        [UniformItemTypes.GoalkeeperTop]: [UniformItemColors.Primary, UniformItemColors.Secondary],
        [UniformItemTypes.GoalkeeperBottom]: [UniformItemColors.Primary],
        [UniformItemTypes.Socks]: [UniformItemColors.Primary],
      },
    },
  ],
};

export const handballConfig: SportConfiguration = {
  ...defaultsConfig,
  fixtureStatuses: [
    ...defaultsConfig.fixtureStatuses,
    FixtureStatuses.WarmUp,
    FixtureStatuses.OnPitch,
    FixtureStatuses.AboutToStart,
  ],
  rosterPositions,
  seasonStaffRoles,
  fixtureStaffRoles,
  uniforms,
};
